<div class="lui-select-box-ripple" mat-ripple></div>
<div class="lui-select-box-border-thin"></div>
<div class="lui-select-box-border-thick"></div>

<ng-content select="[luiSelectBoxContent]"></ng-content>

<div class="lui-select-box-main position-relative">
  <div class="lui-select-box-indicator">
    <mat-icon *ngIf="_selected" svgIcon="tick"></mat-icon>
  </div>
  <div class="lui-select-box-text">
    <ng-content></ng-content>
  </div>
</div>
